import { Phone } from "lucide-react";
import { LOGO, CONTACTS } from "@/data";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  const links = [
    { id: "services", label: t.nav.services },
    { id: "portfolio", label: t.nav.work },
    { id: "manifesto", label: t.nav.why },
    { id: "testimonials", label: t.nav.reviews },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer className="relative bg-[#050505] border-t border-[#d4af37]/15 overflow-hidden" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 pt-24 pb-10">
        <div className="flex flex-col items-center text-center">
          <img src={LOGO} alt="Banman's Painting" className="h-24 w-24 rounded-full object-cover ring-1 ring-[#d4af37]/40 mb-8" />
          <h2 className="font-serif-lux font-light text-6xl sm:text-8xl lg:text-[11rem] leading-[0.85] tracking-tighter text-white select-none">
            BANMAN&apos;S
          </h2>
          <p className="mt-4 text-[#d4af37] uppercase tracking-[0.35em] text-xs">Isaiah 40:31</p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/10 pt-12">
          <div>
            <h4 className="text-white/40 uppercase tracking-[0.2em] text-xs mb-4">{t.footer.explore}</h4>
            <ul className="space-y-2">
              {links.map((l) => (
                <li key={l.id}>
                  <button onClick={() => scrollTo(l.id)} className="text-white/70 hover:text-[#d4af37] transition-colors duration-300" data-testid={`footer-link-${l.id}`}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white/40 uppercase tracking-[0.2em] text-xs mb-4">{t.footer.callUs}</h4>
            <ul className="space-y-3">
              {CONTACTS.map((c) => (
                <li key={c.tel}>
                  <a href={`tel:${c.tel}`} className="flex items-center gap-2 text-white/70 hover:text-[#d4af37] transition-colors duration-300">
                    <Phone size={15} /> {c.name} &middot; {c.phone}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white/40 uppercase tracking-[0.2em] text-xs mb-4">{t.footer.serviceArea}</h4>
            <p className="text-white/70 font-light">{t.footer.area}</p>
            <p className="text-white/50 font-light mt-2">{t.footer.tagline}</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/40 text-sm">
          <p>&copy; {new Date().getFullYear()} Banman&apos;s Painting. {t.footer.rights}</p>
          <p>{t.footer.pro}</p>
        </div>
      </div>
    </footer>
  );
}
